<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{
        group != null ? group.name : onlineOnly ? "Message Online Drivers" : "Message All Drivers"
      }}</span>
    </v-card-title>
    <v-layout pa-2 px-3 row wrap>
      <v-flex xs12>
        <v-textarea
          v-model="message"
          maxlength="500"
          label="Message"
          placeholder="Enter your message"
        ></v-textarea>
      </v-flex>
      <v-flex xs12>
        <p style="color: red">{{ error }}</p>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="text-none" text @click="sent">Cancel</v-btn>
      <v-btn class="text-none" text @click="sendMessage"
        >Send Message</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "MessageDriverDialog",
  model: {
    prop: "time",
    event: "input",
  },
  props: {
    onlineOnly: Boolean,
    group: Object,
  },
  data() {
    return {
      message: "",
      error: "",
    };
  },
  methods: {
    sent: function () {
      this.$emit("sent");
    },
    sendMessage: async function () {
      this.$emit("sent", this.message);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
